<div class="row justify-content-center" *ngIf="orderDetails$ | async as order">
  <div class="col-12 col-md-8 col-lg-6 mb-10">
    <!-- title and icon -->
    <div class="d-flex justify-content-center mb-6" style="--svg-dimension: 2.5rem">
      <app-svg iconName="DeliveryTruck" dimension="5rem"></app-svg>
    </div>
    <h2 class="text-center mx-auto mb-6 mb-md-8">
      {{ 'habaConfirmation.thankYouHeading' | cxTranslate }}
    </h2>
    <!-- email confirmation -->
    <div class="text-center pb-9 px-6 px-md-10 fs-16">
      <!-- card for new user -->

      <div
        *ngIf="isNewRegisteredUser && (isCompany$ | async) === false"
        class="d-flex flex-column my-6 my-md-9 card-confirmation gap-16"
      >
        <div class="d-flex flex-row align-items-center gap-8">
          <app-svg iconName="Mail" dimension="2rem"></app-svg>
          <h4>{{ 'habaConfirmation.pleaseConfirm' | cxTranslate }}</h4>
        </div>
        <p>
          {{ 'habaConfirmation.securityPartOne' | cxTranslate }}
          <strong>{{ order.orderEmail }}</strong>
          {{ 'habaConfirmation.securityPartTwo' | cxTranslate }}
        </p>
        <strong>{{ 'habaConfirmation.confirmationLink' | cxTranslate }}</strong>
        <p>{{ 'habaConfirmation.accountDeletion' | cxTranslate }}</p>
      </div>

      <span>{{ 'habaConfirmation.thankYouText' | cxTranslate }}</span>
      <br /><br />
      <strong [attr.data-qa]="emailTextQaId.getTextId()">{{ order.orderEmail }}</strong>
      <br /><br />
      <strong>{{ 'habaConfirmation.total' | cxTranslate }}</strong>
      <br />
      <strong [attr.data-qa]="orderTotalTextQaId.getTextId()">{{ order.orderTotal }}</strong>
      <br />
      <!-- log in -->
      @if ((isLogin$ | async) === false && !isNewRegisteredUser) {
        <p
          [innerHtml]="
            'habaConfirmation.orderDetailsRedirectGuestMessage'
              | cxTranslate: { myOrders: orderStatusUrl }
          "
        ></p>
      }

      <!-- guest -->
      @else if (
        (isLogin$ | async) ||
        (!isNewRegisteredUser && (isCompany$ | async) === false) ||
        (isNewRegisteredUser && (isCompany$ | async))
      ) {
        <p
          [innerHtml]="
            'habaConfirmation.myAccountRedirectMessage' | cxTranslate: { myOrders: myOrdersUrl }
          "
        ></p>
      }
      <!-- new account -->
      @else if (isNewRegisteredUser) {
        <p>
          {{ 'habaConfirmation.myAccountAfterConfirmMessage' | cxTranslate }}
        </p>
      }

      <div class="d-flex justify-content-center info-box">
        <app-svg iconName="Info" dimension="1.375rem"></app-svg>
        <p [innerHtml]="'habaConfirmation.infoBoxMessage' | cxTranslate"></p>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <!-- new account -->
      <a
        [attr.data-qa]="toHomeButtonQaId.getButtonId()"
        (click)="logout()"
        [routerLink]="{ cxRoute: 'home' } | cxUrl"
        class="btn btn-primary button-style"
        [class.btn-secondary]="isNewRegisteredUser"
      >
        {{ 'habaCart.toHome' | cxTranslate }}
      </a>
    </div>
  </div>
</div>
